import React from 'react';

import Login from '../Containers/LoginContainer';


const login = (props) => {

	return (
		<Login action="show" show="login"/>
	);
}

export default login;